module.exports = __webpack_public_path__ + "img/dwyyyy.ad9cfd2a.png";